export class SearchText {
    CompanyId: number;
    UserTypeId: number;
    FilterTexts: string;
    UnitId: number;
    ModuleId: number = -1;
}
